"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

var _navigationModule = _interopRequireDefault(require("./navigation.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NavMenuContext = require("./NavMenuContext");

var _useOutsideAlerter = require("../../../utils/hooks/useOutsideAlerter");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var NavUser = function NavUser(props) {
  var id = props.id,
      useImageId = props.useImageId,
      options = props.options,
      dropdownLabel = props.dropdownLabel;

  var _useContext = (0, _react.useContext)(_NavMenuContext.NavMenuContext),
      expandedMenuId = _useContext.expandedMenuId,
      handleMenuClick = _useContext.handleMenuClick;

  var isExpanded = expandedMenuId === id;
  var wrapperRef = (0, _react.useRef)(null);
  var itemRefToExclude = (0, _react.useRef)(null);
  (0, _useOutsideAlerter.useOutsideAlerter)(wrapperRef, function () {
    return handleMenuClick(id);
  }, [itemRefToExclude]);
  return _react.default.createElement("ul", {
    id: id ? id : null,
    className: (0, _classnames.default)(_themeModule.default.arag, _navigationModule.default["nav"], _navigationModule.default["navbar-nav"], _navigationModule.default["navbar-right"])
  }, _react.default.createElement("li", {
    id: id ? "".concat(id, "_item") : null,
    className: isExpanded ? _navigationModule.default["open"] : null
  }, _react.default.createElement("a", {
    id: id ? "".concat(id, "_item_button") : null,
    ref: itemRefToExclude,
    className: _navigationModule.default["dropdown-toggle"],
    "data-toggle": "dropdown",
    role: "button",
    "aria-haspopup": "true",
    "aria-expanded": "false",
    onClick: function onClick() {
      return handleMenuClick(id);
    }
  }, _react.default.createElement("span", {
    id: id ? "".concat(id, "_item_label") : null
  }, dropdownLabel), _react.default.createElement("span", {
    id: id ? "".concat(id, "_item_caret") : null,
    className: _navigationModule.default.caret
  })), isExpanded && _react.default.createElement("ul", {
    id: id ? "".concat(id, "_menu_list") : null,
    className: _navigationModule.default["dropdown-menu"],
    ref: wrapperRef,
    style: {
      display: "block"
    }
  }, _react.default.createElement("li", {
    id: id ? "".concat(id, "_menu_item") : null
  }, options.map(function (option, index) {
    return _react.default.createElement("a", {
      id: id ? "".concat(id, "_menu_item_").concat(index) : null,
      key: index,
      href: option.href ? option.href : '#',
      onClick: option.callback
    }, option.label);
  })))), _react.default.createElement("li", null, useImageId && _react.default.createElement("img", {
    id: useImageId,
    className: _navigationModule.default["user-image"]
  })));
};

NavUser.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    callback: _propTypes.default.func
  })).isRequired,
  useImageId: _propTypes.default.string,
  spanId: _propTypes.default.string,
  dropdownLabel: _propTypes.default.string
};
var _default = NavUser;
exports.default = _default;